import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function InfoDialog({
  open,
  onClose,
  title,
  description = "Additional information will be displayed here.",
  downloadUrl,
  downloadText,
  onDownload,
  actions,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography align="center" fontSize={20} fontWeight={500} color="text.primary">
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography color="text.primary" align="center">
          {description}
        </Typography>
        {(downloadUrl || onDownload) && (
          <Button
            component={onDownload ? "button" : "a"}
            href={onDownload ? undefined : downloadUrl}
            target={onDownload ? undefined : "_blank"}
            download={onDownload ? undefined : true}
            onClick={onDownload}
            variant="text"
            fullWidth
            color="primary"
            sx={{ mt: 1 }}
          >
            {downloadText}
          </Button>
        )}
      </DialogContent>
      {actions && <DialogActions sx={{ px: 3, pb: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
}
